var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoachTalk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_40649",
    "data-name": "Gruppe 40649",
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_40452",
    "data-name": "Gruppe 40452",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_529",
    "data-name": "Ellipse 529",
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#e5f5f2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_40651",
    "data-name": "Gruppe 40651",
    transform: "translate(15.521 17.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_48015",
    "data-name": "Pfad 48015",
    d: "M8.464,67.787A13.166,13.166,0,0,1,5,67.076c1.406-1.416,2.774-2.77,2.589-4.957h-3.4A4.23,4.23,0,0,1,0,57.884V41.64a4.23,4.23,0,0,1,4.192-4.234H30.834a4.172,4.172,0,0,1,4.124,4.234V57.884a4.172,4.172,0,0,1-4.124,4.234H14.961A6.693,6.693,0,0,1,8.464,67.787Zm-4.271-28.3A2.133,2.133,0,0,0,2.08,41.64V57.884a2.134,2.134,0,0,0,2.112,2.15H9.241a7.577,7.577,0,0,1-.36,5.648,4.587,4.587,0,0,0,3.078-1.666,5.9,5.9,0,0,0,1.035-3.982H30.834a2.134,2.134,0,0,0,2.112-2.15V41.64a2.133,2.133,0,0,0-2.112-2.15Z",
    transform: "translate(0 -37.406)",
    fill: "#1d9d87"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachTalk);
export default __webpack_public_path__ + "static/media/Coach-Talk.926ea70f1a5d1cf57913d2254b608e74.svg";
export { ForwardRef as ReactComponent };